import { render, staticRenderFns } from "./speedBump.vue?vue&type=template&id=4efc7e92&"
import script from "./speedBump.vue?vue&type=script&lang=js&"
export * from "./speedBump.vue?vue&type=script&lang=js&"
import style0 from "./speedBump.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports